import MuiTableContainer from '@mui/material/TableContainer';
import { forwardRef } from 'react';
import type { AriaAttributes, ElementType, ReactNode } from 'react';
import { toVendor } from '../styles';
import type { Styleable } from '../styles';
import { EMPHASIS } from '../wrap';
import type { Emphasis } from '../wrap';

/**
 * Written out rather than produced by `wrap` for one reason: callers render it
 * `as={Paper}` and then set the Paper's own `emphasis`. The vendor types that
 * through its polymorphism, which the factory flattens away, so the prop is
 * declared here and forwarded to whatever component actually renders.
 */

export interface TableContainerProps extends Styleable, AriaAttributes {
  as?: ElementType;
  emphasis?: Emphasis;
  id?: string;
  children?: ReactNode;
}

export const TableContainer = forwardRef<HTMLDivElement, TableContainerProps>(
  function TableContainer({ as, emphasis, styles, vendorStyles, ...rest }, ref) {
    return (
      <MuiTableContainer
        ref={ref}
        {...rest}
        {...(as ? { component: as } : {})}
        {...(emphasis ? { variant: EMPHASIS.surface[emphasis] } : {})}
        sx={toVendor(styles, vendorStyles)}
      />
    );
  },
);
